import { ApiFunc, getInstance } from '@helpers/httpClient'

import { MODULES_OUTCOME, MODULES_OUTCOME_LIST, MODULES_OUTCOME_RECALCULATE } from '../constants/api'

const instance = getInstance()

export const modulesOutcome: ApiFunc<`${typeof MODULES_OUTCOME}`, 'get'> = data =>
  instance.get(MODULES_OUTCOME, {
    params: data,
  })

export const modulesOutcomeCreate: ApiFunc<`${typeof MODULES_OUTCOME_LIST}`, 'post'> = data =>
  instance.post(MODULES_OUTCOME_LIST, data)

export const modulesOutcomeList: ApiFunc<`${typeof MODULES_OUTCOME_LIST}`, 'get'> = data =>
  instance.get(MODULES_OUTCOME_LIST, {
    params: data,
  })

export const modulesOutcomeRecalculate: ApiFunc<`${typeof MODULES_OUTCOME_RECALCULATE}`, 'get'> = data =>
  instance.get(MODULES_OUTCOME_RECALCULATE, {
    params: data,
  })
